export default __webpack_public_path__ + "static/media/cancel-order-icon-modal.19dc3705.svg";